module.exports = __webpack_public_path__ + "embed-f481083c480ede6284de8233cf064272.css";